<template>
    <footer>
        <div>
            <router-link :to="{ name: 'home' }" width="75" aria-label="home">
                <img
                    src="/images/pip-global-safety-logo.svg"
                    width="175px"
                    alt="PIP Global Safety logo"
                />
            </router-link>
        </div>
        <div class="footer-links-container row">
            <div class="col-md-3 mt-3">
                <p class="heading">RESOURCES</p>
                <ul class="links">
                    <li>
                        <router-link :to="{ path: '/brands' }"
                            >Brand</router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'company' }"
                            >Company</router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'literature' }"
                            >Product Catalogs</router-link
                        >
                    </li>
                    <li>
                        <router-link :to="{ name: 'privacy' }"
                            >Privacy Policy</router-link
                        >
                    </li>
                    <li>
                        <a
                            href="javascript:void(0)"
                            @click="displayCookiePreference"
                            >Cookie Preference</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://pipglobalsafety.com/sustainability"
                            target="_blank"
                            aria-label="Link opens in new window (pipglobalsafety.com/sustainability)"
                            >Sustainability</a
                        >
                    </li>
                </ul>
            </div>

            <div class="social col-md-3 mt-3">
                <p class="heading d-block">CONNECT WITH US</p>
                <a
                    v-for="social in socialLinks"
                    :key="social.label"
                    :href="social.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="social-link"
                    :aria-label="`${social.label} (opens in a new window)`"
                >
                    <font-awesome-icon
                        class="footer-social-icon"
                        :icon="social.icon"
                    />
                </a>
            </div>
            <div class="contact col-md-3 mt-3">
                <div class="phone">
                    <p class="heading">call us today:</p>
                    <p class="number">
                        <a href="tel:5188610133">(513) 705-2100</a>
                    </p>
                </div>
                <div class="phone">
                    <p class="heading">customer service direct</p>
                    <p class="number">
                        <a href="tel:18009697562">(800) 969-7562</a>
                    </p>
                </div>
            </div>
            <div class="location col-md-3 mt-3">
                <div class="address">
                    <p class="heading">Cincinnati, OH</p>
                    <p class="address">
                        11500 Canal Road<br />Cincinnati, OH 45241
                    </p>
                </div>
                <!-- <div class="address">
                    <p class="heading">global headquarters</p>
                    <p class="address">
                        25 British American Blvd.<br />Latham, NY 12110
                    </p>
                </div> -->
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <p class="my-3 font-weight-light" style="font-size: 0.8rem">
                    Copyright © West Chester Protective Gear 2010 -
                    {{ new Date().getFullYear() }}. All Rights Reserved.
                </p>
            </div>
        </div>
        <!-- <cookie-law theme="pip" :buttonText="text">
            <div slot-scope="props" class="w-100 row p-2">
                <p class="col-9">
                    This site uses cookies to provide you with the best
                    experience possible. By continuing to use this website
                    without modifying your settings, you are consenting to our
                    use of cookies. Learn more and how to manage your settings.
                    <router-link to="/cookies" class="cookie-link"
                        >More Information</router-link
                    >
                </p>
                <button
                    @click="props.accept"
                    class="btn-round-white pt9rem col-3 pipButton"
                >
                    I Accept
                </button>
            </div>
        </cookie-law> -->
    </footer>
</template>

<script>
// import CookieLaw from "vue-cookie-law";
export default {
    data() {
        return {
            socialLinks: [
                {
                    label: "Facebook",
                    href: "https://www.facebook.com/WestChesterGear/",
                    icon: ["fab", "square-facebook"],
                },
                {
                    label: "X",
                    href: "https://www.twitter.com/westchestergear",
                    icon: ["fab", "square-x-twitter"],
                },
                {
                    label: "Instagram",
                    href: "https://www.instagram.com/westchestergear/",
                    icon: ["fab", "square-instagram"],
                },
                {
                    label: "YouTube",
                    href: "https://www.youtube.com/westchestergloves",
                    icon: ["fab", "square-youtube"],
                },
                {
                    label: "LinkedIn",
                    href: "https://www.linkedin.com/company/west-chester-holdings",
                    icon: ["fab", "linkedin"],
                },
            ],
        };
    },
    methods: {
        displayCookiePreference() {
            Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
        },
    },
    // components: { CookieLaw }
};
</script>

<style lang="scss" scoped>
.Cookie--pip {
    background: #111;
    padding: 2rem;
    font-size: 0.9rem;
}

.pipButton {
    line-height: 1;
    max-height: 35px;
    max-width: 100px;
    margin-left: auto;
    font-size: 0.9rem;
}

a {
    color: white;
    font-weight: normal;
}

a.cookie-link {
    color: #01549e;
    margin-left: 0.5rem;
    &:hover {
        text-decoration: underline;
    }
}

.social-link {
    display: inline-flex;
    margin-right: 0.5rem;
}

.footer-social-icon {
    color: white;
    font-size: 2rem;
    height: 1em;
    margin-bottom: 0;
    width: 1em;
}
</style>
